export default __webpack_public_path__ + "static/media/contact_bg.5877f71b.png";